import { _ as _define_property } from "@swc/helpers/_/_define_property";
export var EditMode = /*#__PURE__*/ function(EditMode) {
    EditMode["Enabled"] = "enabled";
    EditMode["Disabled"] = "disabled";
    return EditMode;
}({});
export var NotificationSettingsEntryType = /*#__PURE__*/ function(NotificationSettingsEntryType) {
    NotificationSettingsEntryType["Single"] = "single";
    NotificationSettingsEntryType["Recurring"] = "recurring";
    return NotificationSettingsEntryType;
}({});
export class NotificationSettingsModel {
    static hasRecipients(param) {
        let { recipientTypes } = param;
        return !!recipientTypes.length;
    }
    isRecurring() {
        return this.data.type === "recurring";
    }
    recurringMinutes() {
        if (!this.isRecurring()) return null;
        return this.data.recurring.minutes;
    }
    recurringTimes() {
        if (!this.isRecurring()) return null;
        return this.data.recurring.times;
    }
    makeSingleNotificationSettingsEntryUpdate(recipientTypes) {
        return {
            type: "single",
            recipientTypes
        };
    }
    makeRecurringNotificationSettingsEntryUpdate(recipientTypes, recurring) {
        return {
            type: "recurring",
            recipientTypes,
            recurring
        };
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
